/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Assign_AgentInputs */

const cs_action_assign_agent = /** @type {(inputs: Action_Assign_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiřadit agenta`)
};

const en_action_assign_agent = /** @type {(inputs: Action_Assign_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign agent`)
};

/**
* | output |
* | --- |
* | "Assign agent" |
*
* @param {Action_Assign_AgentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_assign_agent = /** @type {((inputs?: Action_Assign_AgentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Assign_AgentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_assign_agent(inputs)
	return cs_action_assign_agent(inputs)
});